import React, { useState } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import Form from "react-bootstrap/Form";
import Container from "../Container";
import { useMutation } from "react-query";
import Button from "react-bootstrap/Button";
import API from "../../api";
import { rndInt } from "../../helpers/utils";

const EditPlayer = ({
  selectedPlayer,
  players,
  filteredPlayers,
  setPlayers,
  setFilteredPlayers,
  page,
  gotoPage,
  handleClose,
}) => {
  const [firstName, setFirstName] = useState(selectedPlayer.FirstName);
  const [lastName, setLastName] = useState(selectedPlayer.LastName);
  const [cost, setCost] = useState(selectedPlayer.Cost);
  const [status, setStatus] = useState(selectedPlayer.Active);
  const [hidden, setHidden] = useState(selectedPlayer.Hidden);

  const mutation = useMutation({
    mutationFn: (playerInfo) => {
      return API.savePlayerInfo(playerInfo);
    },
    onSuccess: (response, variables, context) => {
      const newPlayers = players.map((player) =>
        player.id === variables.PlayerId ? { ...player, ...variables } : player
      );
      const newFilteredPlayers = filteredPlayers.map((filteredPlayer) =>
        filteredPlayer.id === variables.PlayerId
          ? { ...filteredPlayer, ...variables }
          : filteredPlayer
      );
      setPlayers(newPlayers);
      setFilteredPlayers(newFilteredPlayers);
      setTimeout(() => gotoPage(page), 100);
      handleClose();
    },
  });

  const onChangePlayerFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const onChangePlayerLastName = (e) => {
    setLastName(e.target.value);
  };

  const onChangePlayerStatus = (e) => {
    setStatus(e.target.checked);
  };

  const onChangeVisibilityStatus = (e) => {
    setHidden(e.target.checked);
  };

  const onChangePlayerCost = (e) => {
    setCost(e.target.value);
  };

  return (
    selectedPlayer && (
      <Container style={{ paddingTop: 0 }}>
        <Grid>
          <Row style={{ paddingBottom: 16 }}>
            <Col xs={12} md={10}>
              <img width={40} height={40} src={selectedPlayer?.photo} alt="" />
              &nbsp;{selectedPlayer?.name}
            </Col>
            <Col xs={12} md={2}>
              <div className="logo">
                <img
                  style={{
                    borderRadius: "100%",
                    minHeight: 30,
                    backgrounColor: "#fff",
                  }}
                  src={`https://media-${rndInt()}.api-sports.io/football/teams/${
                    selectedPlayer?.teamId
                  }.png`}
                  width={30}
                  alt=""
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Ім'я гравця:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ім'я"
                  onChange={onChangePlayerFirstName}
                  defaultValue={selectedPlayer?.FirstName}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Прізвище гравця:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Прізвище"
                  onChange={onChangePlayerLastName}
                  defaultValue={selectedPlayer?.LastName}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Label>Вартість гравця:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Вартість"
                  onChange={onChangePlayerCost}
                  defaultValue={selectedPlayer?.Cost}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  onChange={onChangePlayerStatus}
                  defaultChecked={selectedPlayer?.Active}
                  label="Активований"
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  onChange={onChangeVisibilityStatus}
                  defaultChecked={selectedPlayer?.Hidden}
                  label="Прихований"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ paddingTop: 16 }}>
            <Col>
              <Button
                onClick={() =>
                  mutation.mutate({
                    FirstName: firstName,
                    LastName: lastName,
                    Cost: cost,
                    Active: status,
                    Hidden: hidden,
                    PlayerId: selectedPlayer.PlayerId || selectedPlayer.id,
                    TeamId: selectedPlayer.teamId,
                  })
                }
              >
                Зберегти
              </Button>
            </Col>
          </Row>
        </Grid>
      </Container>
    )
  );
};

export default EditPlayer;
